import { z } from "zod"
import { VatRateSchema } from "../invoice/invoice"

export const CustomBookingSectionItemSchema = z.object({
  id: z.guid(),
  name: z.string().min(1),
  description: z.string().nullable(),
  price: z.number().min(0),
  image: z.string().nullable(),
  displayOrder: z.number().min(0),
  category: z.string().nullable(),
  /** Forced VAT rate for this action; null follows the normal VAT rules. */
  vatRate: VatRateSchema.nullable(),
  sectionId: z.guid(),
})

export const CustomBookingSectionSchema = z.object({
  id: z.guid(),
  name: z.string().min(1),
  storeId: z.guid(),
  items: z.array(CustomBookingSectionItemSchema),
})

export const CreateCustomBookingSectionSchema = CustomBookingSectionSchema.omit(
  {
    id: true,
    storeId: true,
    items: true,
  },
)

export const UpdateCustomBookingSectionSchema =
  CreateCustomBookingSectionSchema.partial()

export const CreateCustomBookingSectionItemSchema =
  CustomBookingSectionItemSchema.omit({
    id: true,
    sectionId: true,
  })

export const UpdateCustomBookingSectionItemSchema =
  CreateCustomBookingSectionItemSchema.partial()

export type CustomBookingSection = z.infer<typeof CustomBookingSectionSchema>
export type CustomBookingSectionItem = z.infer<
  typeof CustomBookingSectionItemSchema
>
export type CreateCustomBookingSection = z.infer<
  typeof CreateCustomBookingSectionSchema
>
export type UpdateCustomBookingSection = z.infer<
  typeof UpdateCustomBookingSectionSchema
>
export type CreateCustomBookingSectionItem = z.infer<
  typeof CreateCustomBookingSectionItemSchema
>
export type UpdateCustomBookingSectionItem = z.infer<
  typeof UpdateCustomBookingSectionItemSchema
>
